import {
  Box,
  Flex,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Text,
} from '@chakra-ui/react'
import { ShapeTemplateAttachment } from '@hb/shared'
import { useCallback } from 'react'
import { filteredEvents } from '../../../utils/events'
import { ColorSelect } from '../../ColorSelect'
import { useExternalPdfTemplateEditor } from '../../Templates/ExternalPdf/context'

export const ShapeStyleToolbar: React.FC = () => {
  const { selectedAttachmentId, externalPdf, updateAttachment } = useExternalPdfTemplateEditor()

  const attachment = selectedAttachmentId ? externalPdf.attachments[selectedAttachmentId] : null
  const shapeAttachment = attachment?.type === 'shape' ? attachment : null

  const updateShape = useCallback(
    (patch: Partial<ShapeTemplateAttachment>) => {
      if (!selectedAttachmentId || !shapeAttachment) return
      updateAttachment(selectedAttachmentId, { ...shapeAttachment, ...patch })
    },
    [selectedAttachmentId, shapeAttachment, updateAttachment],
  )

  if (!shapeAttachment) return null

  const label =
    shapeAttachment.shapeType.charAt(0).toUpperCase() + shapeAttachment.shapeType.slice(1)

  return (
    <Flex w="100%" align="center" px={2} gap={2} flexWrap="wrap">
      <Text fontWeight={600} fontSize="sm" flexShrink={0}>
        {label}
      </Text>
      <ColorSelect
        color={shapeAttachment.fillColor}
        setColor={color => updateShape({ fillColor: color ?? undefined })}
      />
      <Box w="1px" h="20px" bg="#cdcdcd" flexShrink={0} />
      <ColorSelect
        color={shapeAttachment.borderColor}
        setColor={color => updateShape({ borderColor: color ?? undefined })}
      />
      <Box pl={1}>
        <NumberInput
          value={shapeAttachment.borderWidth ?? 0}
          {...filteredEvents()}
          onChange={(_, n) => updateShape({ borderWidth: isNaN(n) ? 0 : n })}
          focusInputOnChange={false}
          size="xs"
          maxW={16}
          min={0}
          max={20}
          step={1}>
          <NumberInputField {...filteredEvents()} />
          <NumberInputStepper>
            <NumberIncrementStepper {...filteredEvents()} />
            <NumberDecrementStepper {...filteredEvents()} />
          </NumberInputStepper>
        </NumberInput>
      </Box>
    </Flex>
  )
}
